












import { defineComponent } from '@nuxtjs/composition-api';
import { BaseLink } from '@shared/ui';
import { extractComponents } from '@unified-commerce/gpc-vue-storefront-storyblok';

interface IRenderContent {
  componentName: string;
  props?: Record<string, unknown>;
}

type ApiContent = Record<string, unknown> | [];

export default defineComponent({
  name: 'CMSRenderer',
  components: { BaseLink },
  props: {
    content: {
      type: [Array, Object],
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      contactUsLink: '#',
    };
  },
  computed: {
    components(): IRenderContent[] {
      return extractComponents(this.content as ApiContent);
    },
  },
  methods: {},
});
